var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDwlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.6,10c1.9,1.9,0.1,6.7-1.8,8.6s-1.6-3.1-3.5-5S-2,14.8,1,11.8C2.9,9.9,7.7,8.1,9.6,10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,9.7c-1.9,1.9-6.7,0.1-8.6-1.8c-1.9-1.9,3-1.7,4.9-3.5S11.1-2,14.1,1C16,3,17.8,7.8,16,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.3,16c-1.9-1.9-0.1-6.7,1.8-8.6s1.6,3.1,3.5,5s6.3-1.2,3.3,1.8C23,16.2,18.2,17.9,16.3,16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,16.4c1.9-1.9,6.7-0.1,8.6,1.8c1.9,1.9-3.1,1.6-5,3.5s1.2,6.3-1.8,3.3C9.9,23.1,8.1,18.3,10,16.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwlogo);
export default __webpack_public_path__ + "static/media/dwlogo.9d17600b87e07b9698ba387ec10681a1.svg";
export { ForwardRef as ReactComponent };